// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".location-mobile-task-list{color:#666}.location-mobile-task-list span.description{color:#6860e4;display:block;width:350px}.location-mobile-task-list .alt-color{background-color:#efefef}.location-mobile-task-list hr{margin-bottom:7px;margin-top:7px}", ""]);
// Exports
module.exports = exports;
